import * as gs from "@ivanlog/gs";
import { CmpWidgetVXAppBase } from "./tmpls";
import { BiMath } from "../libs/BiMath";
import { CmpWidgetVXStatus } from "./CmpWidgetVXStatus";
import { ClassesTags } from "../libs/ClassesTags";
import { CmpInputTokenAmount } from "./CmpInputTokenAmount";
import { CmpRange } from "./CmpRange";
import { App } from "../App";
import { VXInfrastructure } from "../contracts/VXInfrastructure";

export class CmpWidgetVXApp extends CmpWidgetVXAppBase {

    private _app:App;
    private _status:CmpWidgetVXStatus;
    private _vxRate:bigint = BiMath.Decimal;
    private _vxAPR:bigint = BiMath.Zero;
    private _vxValidatorGas:bigint = BiMath.Zero;
    private _validatorCost:bigint = BiMath.ToBI("32000000");
    private _pricePLS:bigint = BiMath.Zero;
    private _vxBalance:bigint;
    private _withdrawalPLS:bigint;
    private _withdrawalUPLS:bigint;
    private _plsBalance:bigint;

    private _vxInf:VXInfrastructure;

    constructor() {
        super();
        this._app = App.Inst;

        const stakeT0:CmpInputTokenAmount=this.ctrls.cmpStakeTokens.ctrls.cmpInputTokenAmount0;
        const stakeT1:CmpInputTokenAmount=this.ctrls.cmpStakeTokens.ctrls.cmpInputTokenAmount1;
        const stakeR:CmpRange=this.ctrls.rStakeRangePLS;
        const unstakeT0:CmpInputTokenAmount=this.ctrls.cmpUnstakeTokens.ctrls.cmpInputTokenAmount0;
        const unstakeT1:CmpInputTokenAmount=this.ctrls.cmpUnstakeTokens.ctrls.cmpInputTokenAmount1;
        const btnClaimPLS = this.ctrls.btnClaimPLS;
        const btnClaimUPLS = this.ctrls.btnClaimUPLS;

        stakeT0.setToken("PLS",VXInfrastructure.ADDRESS_ERC20_PLS);
        stakeT1.setToken("uPLS",VXInfrastructure.ADDRESS_ERC20_uPLS);
        unstakeT0.setToken("uPLS",VXInfrastructure.ADDRESS_ERC20_uPLS);
        unstakeT1.setToken("PLS",VXInfrastructure.ADDRESS_ERC20_PLS);

        this.ctrls.aAddUPLSToWallet1.onclick =
        this.ctrls.aAddUPLSToWallet2.onclick = async (e)=>{
            gs.events.stop(e);
            if (!App.chain.account) await App.chain.getAccountAsync();
            if (App.chain.account)
                await App.chain.addTokenToWalletAsync(this._vxInf.vx.address, "uPLS", 18)
        }
        
        this._resetUI();

        this.ctrls.btnConnect.onclick=async ()=>{
            this.ctrls.btnConnect.disable();
            const result = await App.chain.tryConnectAsync();
            this.ctrls.btnConnect.enable();
        }

        this.ctrls.btnTabStake.onclick=()=>this.openTab(this.ctrls.tabStake);
        this.ctrls.btnTabUnstake.onclick=()=>this.openTab(this.ctrls.tabUnstake);

        ///*******************Stake*******************
        let cacheStakeGasValue = BiMath.Zero;
        let cacheStakeValue = BiMath.Zero;
        let cacheStakeVXValue = BiMath.Zero;

        const fillStakeFromCache=()=>{
            let rangeValue = cacheStakeValue * BiMath.Decimal / this._plsBalance;
            this.ctrls.rStakeRangePLS.value = parseInt(parseFloat(BiMath.ToEth(rangeValue))*100+"");

            if (parseFloat(BiMath.ToEth(cacheStakeValue))<1) 
                this.ctrls.btnStake.disable(); else this.ctrls.btnStake.enable();
            if (!App.chain.account) this.ctrls.btnStake.disable(); 
            
            cacheStakeGasValue = cacheStakeValue * this._vxValidatorGas / this._validatorCost;
            if (cacheStakeGasValue==BiMath.Zero) this.ctrls.lValidatorsGas.text = '';
            else this.ctrls.lValidatorsGas.text =  "Gas for validators: " + BiMath.TruncEth(BiMath.ToEth(cacheStakeGasValue),3);

            const price = BiMath.TruncEth(BiMath.ToEth(this._pricePLS*cacheStakeValue/BiMath.Decimal),2)+"$";
            stakeT0.ctrls.lSubText.text =
            stakeT1.ctrls.lSubText.text = price
        }
        stakeR.onChangeValue.addHandler((balancePercent)=>{
            cacheStakeValue = this._plsBalance * BiMath.ToBIFromNumber(balancePercent/100*0.99) / BiMath.Decimal;
            cacheStakeVXValue = cacheStakeValue * BiMath.Decimal / this._vxRate;
            stakeT0.setValueBI(cacheStakeValue);
            stakeT1.setValueBI(cacheStakeVXValue);
            fillStakeFromCache();
        });
        stakeT0.onChangeValue.addHandler((valuePLS)=>{
            cacheStakeValue = valuePLS;
            cacheStakeVXValue = cacheStakeValue * BiMath.Decimal / this._vxRate;
            stakeT1.setValueBI(cacheStakeVXValue);
            fillStakeFromCache();
        });
        stakeT1.onChangeValue.addHandler((valueUPLS)=>{
            cacheStakeVXValue = valueUPLS;  
            cacheStakeValue = cacheStakeVXValue*this._vxRate/BiMath.Decimal
            stakeT0.setValueBI(cacheStakeValue);
            fillStakeFromCache();
        });
        this.ctrls.btnStake.onclick=async()=>{
            const result = await App.gui.awaitInLockUIAsync(
                this._vxInf.vx.stakeAsync(BiMath.ToEth(cacheStakeValue+cacheStakeGasValue), false)
            );
            if (result) { this._successFunc(); await this.refreshAsync(); }
        }
        ///*******************Unstake*******************
        {
            let cacheUnstakeVXValue=BiMath.Zero;
            let cacheUnstakeValue=BiMath.Zero;

            const fillUnstakeFromCache=()=>{
                if (parseFloat(BiMath.ToEth(cacheUnstakeVXValue))<0.001) 
                    this.ctrls.btnUnstake.disable(); else this.ctrls.btnUnstake.enable();
                if (!App.chain.account) this.ctrls.btnUnstake.disable(); 
                  
                const price = BiMath.TruncEth(BiMath.ToEth(this._pricePLS*cacheUnstakeValue/BiMath.Decimal),2)+"$";
                unstakeT0.ctrls.lSubText.text =
                unstakeT1.ctrls.lSubText.text = price
            }
            unstakeT0.onChangeValue.addHandler((valueUPLS)=>{
                cacheUnstakeVXValue = valueUPLS;
                if (cacheUnstakeVXValue>this._vxBalance)
                {
                    cacheUnstakeVXValue = this._vxBalance;
                    unstakeT0.ctrls.iValue.value = BiMath.ToEth(cacheUnstakeVXValue);
                }
                cacheUnstakeValue = cacheUnstakeVXValue*this._vxRate/BiMath.Decimal;
                unstakeT1.setValueBI(cacheUnstakeValue);
                fillUnstakeFromCache();
            });
            unstakeT1.onChangeValue.addHandler((valuePLS)=>{
                cacheUnstakeValue = valuePLS;
                cacheUnstakeVXValue = cacheUnstakeValue * BiMath.Decimal / this._vxRate;
                if (cacheUnstakeVXValue>this._vxBalance)
                {
                    cacheUnstakeVXValue = this._vxBalance;
                    cacheUnstakeValue = cacheUnstakeVXValue*this._vxRate/BiMath.Decimal;
                    unstakeT1.setValueBI(cacheUnstakeValue);
                }
                unstakeT0.setValueBI(cacheUnstakeVXValue);
                fillUnstakeFromCache();
            });

            this.ctrls.btnUnstake.onclick=async()=>{
                const result = await App.gui.awaitInLockUIAsync(
                    this._vxInf.vx.unstakeAsync(BiMath.ToEth(cacheUnstakeVXValue), false)
                );
                if (result) { this._successFunc(); await this.refreshAsync(); }
            }
        }
    }

    public get vxAPR() { return this._vxAPR; }

    public setStatusCmp(status:CmpWidgetVXStatus)
    {
        this._status = status;
    }

    public async refreshAsync()
    {
        const vxInf = App.Inst.getInst(VXInfrastructure);
        this._vxInf=vxInf;
        const ctrls = this.ctrls;
        ctrls.rStakeRangePLS.hide();

        const account = App.chain.account;
        const vxData = await vxInf.vcontroller.getVXRateAsync();

        this._resetUI();

        this._vxAPR = BiMath.ToBI(vxData.apr);
        this._vxRate = BiMath.ToBI(vxData.vxRatio);

        if (this._status)
            await this._status.refreshAsync(vxData, vxInf.vx, vxInf.vpool, vxInf.vcontroller, App.chain.account);

        this._vxBalance = this._status.vxBalance;

        const vxValidatorGas = await vxInf.vcontroller.getValidatorGas();
        this._vxValidatorGas = BiMath.ToBI(vxValidatorGas);

        const pricePLS = await vxInf.priceKeeperPLS.getPrice();
        this._pricePLS = BiMath.ToBI(pricePLS);

        if (account)
        {
            const plsBalance = await App.chain.getBalanceEth();
            this._plsBalance = BiMath.ToBI(plsBalance);

            ctrls.rStakeRangePLS.show();
            ctrls.btnConnect.hide();
            ctrls.btnStake.show();
            ctrls.btnTabUnstake.enable();

            const withdrawalPLS = await vxInf.vx.getWithdrawalAsync(account);
            this._withdrawalPLS = BiMath.ToBI(withdrawalPLS);
            let needShowClaimBtns=false;
            if (this._withdrawalPLS>0)
            {
                needShowClaimBtns=true;
                const btnClaimPLS = this.ctrls.btnClaimPLS;
                let exist = this._status.vxInstWithdrawal;
                if (exist>=this._withdrawalPLS)
                {
                    exist = this._withdrawalPLS;
                    btnClaimPLS.ctrls.btn.html=`Claim ${BiMath.TruncEth(BiMath.ToEth(exist), 3)} PLS`;
                } else
                {
                    btnClaimPLS.ctrls.btn.html=`Claim ${BiMath.TruncEth(BiMath.ToEth(exist), 3)} PLS`;
                    btnClaimPLS.ctrls.lTag.text = BiMath.ToEth(this._withdrawalPLS)+" PLS";
                    btnClaimPLS.ctrls.lTag.show();
                }
                if (exist==BiMath.Zero) btnClaimPLS.disable(); else 
                {
                    
                    btnClaimPLS.enable();
                    btnClaimPLS.onclick=async ()=>{
                        const result = await App.gui.awaitInLockUIAsync(
                            vxInf.vx.withdraw(BiMath.ToEth(exist), App.chain.account)
                        );
                        if (result) { this._successFunc(); await this.refreshAsync(); }
                    };
                }
            }
            const withdrawalUPLS = await vxInf.vx.getReserveOfAsync(account);
            this._withdrawalUPLS = BiMath.ToBI(withdrawalUPLS.value);
            if (this._withdrawalUPLS>0)
            {
                needShowClaimBtns=true;
                this.ctrls.btnClaimUPLS.onclick=async ()=>{
                    const result = await App.gui.awaitInLockUIAsync(
                        vxInf.vx.withdrawReserveAsync()
                    );
                    if (result) { this._successFunc(); await this.refreshAsync(); }
                }
                const cooldownDelta = parseInt(withdrawalUPLS.cooldownUntil)-Date.now()/1000;
                this.ctrls.btnClaimUPLS.enable();
                this.ctrls.btnClaimUPLS.ctrls.btn.html = `Claim ${BiMath.TruncEth(BiMath.ToEth(this._withdrawalUPLS),3)} uPLS`;
                this.ctrls.btnClaimUPLS.ctrls.lTag.hide();
                if (cooldownDelta>0)
                {
                    this.ctrls.btnClaimUPLS.disable();
                    this.ctrls.btnClaimUPLS.ctrls.lTag.text = "cooldown "+(parseInt(cooldownDelta/60+"")+1)+" mins";
                    this.ctrls.btnClaimUPLS.ctrls.lTag.show();
                }
            } 

            ctrls.blockBtnsClaim.showSet(needShowClaimBtns);
        } else
        {
            ctrls.btnConnect.show();
            ctrls.btnStake.hide();
            ctrls.btnTabUnstake.disable();
            this.openTab(ctrls.tabStake);
        }
    }

    public openTab(tab:gs.WrapperGS)
    {
        const ctrls = this.ctrls;
        if (ctrls.tabStake==tab)
        {
            ctrls.tabStake.show();
            ctrls.tabUnstake.hide();
            ctrls.btnTabStake.addClass(ClassesTags.Active);
            ctrls.btnTabUnstake.removeClass(ClassesTags.Active);
        } else
        {
            ctrls.tabStake.hide();
            ctrls.tabUnstake.show();
            ctrls.btnTabStake.removeClass(ClassesTags.Active);
            ctrls.btnTabUnstake.addClass(ClassesTags.Active);
        }
    }

    private _successFunc(){ App.gui.dialogOkShowAsync("The transaction was completed successfully.","Information");}

    private _resetUI()
    {
        const stakeT0:CmpInputTokenAmount=this.ctrls.cmpStakeTokens.ctrls.cmpInputTokenAmount0;
        const stakeT1:CmpInputTokenAmount=this.ctrls.cmpStakeTokens.ctrls.cmpInputTokenAmount1;
        const unstakeT0:CmpInputTokenAmount=this.ctrls.cmpUnstakeTokens.ctrls.cmpInputTokenAmount0;
        const unstakeT1:CmpInputTokenAmount=this.ctrls.cmpUnstakeTokens.ctrls.cmpInputTokenAmount1;
        const btnClaimPLS = this.ctrls.btnClaimPLS;
        const btnClaimUPLS = this.ctrls.btnClaimUPLS;

        btnClaimPLS.ctrls.btn.text="Claim PLS";
        btnClaimPLS.ctrls.lTag.hide();
        btnClaimPLS.disable();
        btnClaimUPLS.ctrls.btn.text="Claim uPLS";
        btnClaimUPLS.ctrls.lTag.hide(); 
        btnClaimUPLS.disable();
        this.ctrls.blockBtnsClaim.hide();

        this.ctrls.lValidatorsGas.text = "";
        stakeT0.ctrls.lSubText.text =
        stakeT1.ctrls.lSubText.text = 
        unstakeT0.ctrls.lSubText.text =
        unstakeT1.ctrls.lSubText.text = '';
        this.ctrls.btnStake.hide();
        stakeT0.ctrls.iValue.value=
        stakeT1.ctrls.iValue.value=
        unstakeT0.ctrls.iValue.value=
        unstakeT1.ctrls.iValue.value='';
    }
}